import { defineStore } from 'pinia'

interface PhoneState {
  ctn: string
}

interface PhoneActions {
  setCtn: (newCtn: string) => void
  getCtn: () => string
}

export const usePhoneStore = defineStore<
  'phone',
  PhoneState,
  Record<string, any>,
  PhoneActions
>({
  id: 'phone',
  state: (): PhoneState => ({
    ctn: '',
  }),
  actions: {
    setCtn(newCtn: string) {
      this.ctn = newCtn
    },
    getCtn(): string {
      return this.ctn
    },
  },
})
